exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wp_img_round[data-v-283fd360]{border-radius:50%}.wp_img_app[data-v-283fd360]{border-radius:10px}.shadow[data-v-283fd360]{filter:progid:DXImageTransform.Microsoft.Shadow(color=#909090,direction=120,strength=4);-webkit-box-shadow:2px 2px 10px #909090;box-shadow:2px 2px 10px #909090}", ""]);

// exports
